import linkifyHtml from 'linkify-html';

// Customer-facing linkify: URL/email autolinks only, never internal admin
// links. Input must already be safe HTML (escape plain text first).
export function Linkify(inputHtml: string): string {
    return linkifyHtml(inputHtml, {
        nl2br: false,
        target: '_blank',
        rel: 'noopener noreferrer',
        ignoreTags: ['a', 'script', 'style', 'textarea', 'code'],
    });
}
